<template>
    <DCard>
        <div class="search">
            <DRow>
                <DCol sm="8">
                    <h6>
                        {{ __('messages.search') }}
                    </h6>
                </DCol>
                <DCol sm="2">
                    <h6>
                        {{ __('settings.orders.manual_checks.inactive') }}
                    </h6>
                </DCol>
            </DRow>
            <DRow>
                <DCol sm="8">
                    <DInput
                        id="search"
                        v-model="filter.search"
                        :placeholder="__('settings.orders.manual_checks.search')"
                    />
                </DCol>
                <DCol sm="2">
                    <DSwitch
                        id="inactive"
                        color="success"
                        variant="3d"
                        :checked="shouldIncludeInactive"
                        @update:checked="updateInactive"
                    />
                </DCol>
                <DCol sm="2">
                    <DButton
                        id="filter-apply"
                        :label="__('messages.actions.filter')"
                        @click="submitFilters"
                    />
                    <DButton
                        id="filter-reset"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
        </div>
        <section class="checks-table">
            <div class="table-header">
                <div>
                    <DButton
                        mini
                        :icon="collapsedGroups.length > 0 ? 'arrow-down' : 'arrow-up'"
                        @click="toggleAll()"
                    />
                </div>
                <div>{{ __('settings.orders.manual_checks.id') }}</div>
                <div>{{ __('settings.orders.manual_checks.name') }}</div>
                <div />
            </div>
            <main>
                <div
                    v-for="(item, index) in manualCheckGroups"
                    :key="index"
                    class="item-group"
                >
                    <div class="item-header">
                        <div>
                            <DButton
                                :id="`toggle_group_${index}`"
                                mini
                                :icon="collapsedGroups.includes(index) ? 'arrow-down' : 'arrow-up'"
                                @click="toggleGroup(index)"
                            />
                        </div>
                        <div>
                            {{ item.name }}
                            <DBadge
                                v-if="!item.active"
                                color="info"
                            >
                                {{ __('settings.orders.manual_checks.inactive') }}
                            </DBadge>
                        </div>
                        <div class="buttons">
                            <DButton
                                v-if="userPermissions.includes('setting.orders')"
                                :id="`edit_group_${item.id}`"
                                icon="pencil"
                                mini
                                :href="editCheckGroup(item.id)"
                            />
                        </div>
                    </div>
                    <div
                        v-for="(check, indexCheck) in item.order_manual_checks"
                        v-show="!collapsedGroups.includes(index)"
                        :key="indexCheck"
                        class="item"
                    >
                        <div />
                        <div>{{ check.id }}</div>
                        <div class="wrap-text">
                            {{ check.name }}
                            <DBadge
                                v-if="!check.active"
                                color="info"
                            >
                                {{ __('settings.orders.manual_checks.inactive') }}
                            </DBadge>
                        </div>
                        <div class="buttons">
                            <DButton
                                v-if="userPermissions.includes('setting.orders')"
                                :id="`edit_check_${check.id}`"
                                icon="pencil"
                                mini
                                :href="editCheckLink(check.id)"
                            />
                        </div>
                    </div>
                </div>
            </main>
        </section>

        <DFabs>
            <DFab
                v-if="userPermissions.includes('setting.orders')"
                id="btn-add"
                icon="plus"
                :label="__('settings.orders.manual_checks.add_check')"
                @click="$inertia.get($route('settings.order-manual-check-settings.create'))"
            />
        </DFabs>
    </DCard>
</template>

<script>

export default {
    name: 'ManualCheckGroupsIndex',
    props: {
        manualCheckGroups: {
            type: Array,
            required: true
        },
        filterData: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            collapsedGroups: [],
            filter: {
                search: (this.filterData !== null && this.filterData.search) || this.getParam('search'),
                inactive: (this.filterData !== null && this.filterData.inactive) || this.getParam('inactive')
            }
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        shouldIncludeInactive () {
            return Number(this.filter.inactive) !== 0
        }
    },
    methods: {
        editCheckGroup (id) {
            return this.$route('settings.order-manual-check-group-settings.edit', { order_manual_check_group_setting: id })
        },
        editCheckLink (id) {
            return this.$route('settings.order-manual-check-settings.edit', { order_manual_check_setting: id })
        },
        toggleGroup (groupId) {
            if (this.collapsedGroups.includes(groupId)) {
                this.collapsedGroups = this.collapsedGroups.filter(e => e !== groupId)
            } else {
                this.collapsedGroups.push(groupId)
            }
        },
        toggleAll () {
            if (this.collapsedGroups.length > 0) {
                this.collapsedGroups = []
            } else {
                this.manualCheckGroups.forEach((manualCheckGroup, index) => {
                    if (!this.collapsedGroups.includes(index)) {
                        this.collapsedGroups.push(index)
                    }
                })
            }
        },
        updateInactive (values) {
            this.filter.inactive = values ? 1 : 0
        },
        submitFilters () {
            this.$inertia.get(this.$route('settings.order-manual-check-group-settings.index', {
                _query: this.filter,
                saveFilters: true
            }))
        },
        resetFilters () {
            this.$inertia.get(this.$route('settings.order-manual-check-group-settings.index', {
                saveFilters: true,
                defaultFilters: true
            }))
        },
        getParam (paramName) {
            const params = new URLSearchParams(window.location.search)
            return params.has(paramName) ? params.get(paramName) : null
        }
    }
}
</script>

<style scoped lang="scss">
.checks-table {
    & .table-header {
        border-bottom: 1px solid rgba(0,0,0,0.14);
        display: grid;
        grid-template-columns: 45px 100px 1fr 70px;
        grid-gap: 10px;
        align-items: center;

        & > div {
            padding: 10px;
            font-weight: bold;
        }
    }
    & main {
        & .item-group {
            border-bottom: 1px solid rgba(0,0,0,0.3);
            position: relative;

            & .item-header {
                display: grid;
                grid-template-columns: 45px 100px 1fr 70px;
                grid-gap: 10px;
                background: #fff;
                border-bottom: 1px solid rgba(0,0,0,0.14);
                position: sticky;
                top: -25px;
                width: 100%;
                z-index: 100;

                & > div {
                    padding: 10px;
                    align-self: center;
                }
                & > div:nth-child(2) {
                    grid-column: 2 / span 2;
                    font-weight: bold;
                }
            }
            & .item {
                display: grid;
                grid-template-columns: 45px 100px 1fr 70px;
                grid-gap: 10px;

                & > div {
                    padding: 10px;
                    align-self: center;
                }
                & > div:nth-child(1) {
                    position: relative;
                    overflow: hidden;
                    padding: 0;
                    height: 100%;

                    &::after {
                        content: "";
                        display: block;
                        position: absolute;
                        left: 29px;
                        top: 0px;
                        width: 2px;
                        height: 60px;
                        background: rgba(0,0,0,0.08);
                    }
                    &::before {
                        content: "";
                        display: block;
                        position: absolute;
                        left: 31px;
                        top: 25px;
                        width: 10px;
                        border-top-right-radius: 4px;
                        border-bottom-right-radius: 4px;
                        height: 2px;
                        background: rgba(0,0,0,0.08);
                    }
                }
                &:last-of-type > div:nth-child(1)::after {
                    height: 35px;
                    background: rgba(0,0,0,0.07);
                    border-bottom-left-radius: 4px;
                    border-bottom-right-radius: 4px;
                }

                &:hover {
                    background: rgba(0,0,0,0.07);
                }
            }
        }
    }
}
.search {
    padding: 7px 7px 7px 14px;
    border-bottom: var(--colorAppBorder) solid 1px;
}
.buttons {
    display: flex;
    grid-gap: 10px;
}
.wrap-text {
    white-space: pre-wrap;
}
</style>
